require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("leaflet"), require("react"), require("react-leaflet"), require("google-maps")) : "function" == typeof define && define.amd ? define(["leaflet", "react", "react-leaflet", "google-maps"], e) : "object" == typeof exports ? exports.ReactLeaflet = e(require("leaflet"), require("react"), require("react-leaflet"), require("google-maps")) : t.ReactLeaflet = e(t.L, t.React, t[void 0], t.GoogleMapsLoader);
}(window, function (t, e, i, n) {
  return function (t) {
    var e = {};

    function i(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, n) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        i.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 3);
  }([function (t, e) {
    t.exports = function (t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    };
  }, function (t, e, i) {
    var n = i(5);

    function o() {
      if ("function" != typeof WeakMap) return null;
      var t = new WeakMap();
      return o = function o() {
        return t;
      }, t;
    }

    t.exports = function (t) {
      if (t && t.__esModule) return t;
      if (null === t || "object" !== n(t) && "function" != typeof t) return {
        "default": t
      };
      var e = o();
      if (e && e.has(t)) return e.get(t);
      var i = {},
          r = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var a in t) {
        if (Object.prototype.hasOwnProperty.call(t, a)) {
          var s = r ? Object.getOwnPropertyDescriptor(t, a) : null;
          s && (s.get || s.set) ? Object.defineProperty(i, a, s) : i[a] = t[a];
        }
      }

      return i["default"] = t, e && e.set(t, i), i;
    };
  }, function (e, i) {
    e.exports = t;
  }, function (t, e, i) {
    "use strict";

    var n = i(0);
    e.__esModule = !0, e.GoogleLayer = void 0;
    var o = n(i(4));
    e.GoogleLayer = o["default"];
  }, function (t, e, i) {
    "use strict";

    var n = i(1),
        o = i(0);
    e.__esModule = !0, e["default"] = void 0;
    var r = o(i(6)),
        a = o(i(7)),
        s = (o(i(8)), o(i(9))),
        l = n(i(2)),
        u = i(12);
    i(13);

    var c = function (t) {
      function e() {
        return t.apply(this, arguments) || this;
      }

      (0, r["default"])(e, t);
      var i = e.prototype;
      return i.createLeafletElement = function (t) {
        return this.leafletElement = new l.gridLayer.googleMutant(t), this.leafletElement;
      }, i.updateLeafletElement = function (t, e) {
        var i = e.opacity,
            n = e.zIndex;
        i !== t.opacity && this.leafletElement.setOpacity(i), n !== t.zIndex && this.leafletElement.setZIndex(n);
      }, e;
    }(u.GridLayer);

    (0, a["default"])(c, "propTypes", {
      googlekey: s["default"].string.isRequired,
      maptype: s["default"].string,
      asclientid: s["default"].bool,
      channel: s["default"].string
    }), (0, a["default"])(c, "contextTypes", u.GridLayer.contextTypes), (0, a["default"])(c, "childContextTypes", u.GridLayer.childContextTypes);
    var p = (0, u.withLeaflet)(c);
    e["default"] = p;
  }, function (t, e) {
    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function n(e) {
      return "function" == typeof Symbol && "symbol" === i(Symbol.iterator) ? t.exports = n = function n(t) {
        return i(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : i(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e) {
    t.exports = function (t, e) {
      t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
    };
  }, function (t, e) {
    t.exports = function (t, e, i) {
      return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = i, t;
    };
  }, function (t, i) {
    t.exports = e;
  }, function (t, e, i) {
    t.exports = i(10)();
  }, function (t, e, i) {
    "use strict";

    var n = i(11);

    function o() {}

    function r() {}

    r.resetWarningCache = o, t.exports = function () {
      function t(t, e, i, o, r, a) {
        if (a !== n) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function e() {
        return t;
      }

      t.isRequired = t;
      var i = {
        array: t,
        bool: t,
        func: t,
        number: t,
        object: t,
        string: t,
        symbol: t,
        any: t,
        arrayOf: e,
        element: t,
        elementType: t,
        instanceOf: e,
        node: t,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: r,
        resetWarningCache: o
      };
      return i.PropTypes = i, i;
    };
  }, function (t, e, i) {
    "use strict";

    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (t, e) {
    t.exports = i;
  }, function (t, e, i) {
    "use strict";

    var n,
        o = i(1),
        r = i(0)(i(14)),
        a = o(i(2));
    a.GridLayer.GoogleMutant = a.GridLayer.extend({
      includes: a.Evented,
      options: {
        minZoom: 0,
        maxZoom: 21,
        tileSize: 256,
        subdomains: "abc",
        errorTileUrl: "",
        attribution: "",
        opacity: 1,
        continuousWorld: !1,
        noWrap: !1,
        type: "HYBRID",
        maxNativeZoom: 21
      },
      initialize: function initialize(t) {
        a.GridLayer.prototype.initialize.call(this, t);
        var e = this;
        r["default"].VERSION = t.version || "3.38", t.asclientid ? r["default"].CLIENT = t.googlekey : r["default"].KEY = t.googlekey, r["default"].LIBRARIES = t.libraries || [], t.channel && (r["default"].CHANNEL = t.channel), e._type = t.maptype || "SATELLITE", r["default"].load(function (i) {
          n = i, e._ready = !0, e._initMutant(), e._update(), t.onAfterLoad && t.onAfterLoad(n);
        }), this._tileCallbacks = {}, this._freshTiles = {}, this._imagesPerTile = "HYBRID" === e._type ? 2 : 1, this.createTile = "HYBRID" === e._type ? this._createMultiTile : this._createSingleTile;
      },
      onAdd: function onAdd(t) {
        a.GridLayer.prototype.onAdd.call(this, t), this._initMutantContainer(), r["default"].load(function (e) {
          this._map = t, this._initMutant(), t.on("viewreset", this._reset, this), t.on("move", this._update, this), t.on("zoomend", this._handleZoomAnim, this), t.on("resize", this._resize, this), t._controlCorners && (t._controlCorners.bottomright.style.marginBottom = "20px"), this._reset(), this._update();
        }.bind(this));
      },
      onRemove: function onRemove(t) {
        a.GridLayer.prototype.onRemove.call(this, t), t._container.removeChild(this._mutantContainer), this._mutantContainer = void 0, t.off("viewreset", this._reset, this), t.off("move", this._update, this), t.off("zoomend", this._handleZoomAnim, this), t.off("resize", this._resize, this), t._controlCorners && (t._controlCorners.bottomright.style.marginBottom = "0em");
      },
      getAttribution: function getAttribution() {
        return this.options.attribution;
      },
      setOpacity: function setOpacity(t) {
        this.options.opacity = t, t < 1 && a.DomUtil.setOpacity(this._mutantContainer, t);
      },
      setElementSize: function setElementSize(t, e) {
        t.style.width = e.x + "px", t.style.height = e.y + "px";
      },
      _initMutantContainer: function _initMutantContainer() {
        this._mutantContainer || (this._mutantContainer = a.DomUtil.create("div", "leaflet-google-mutant leaflet-top leaflet-left"), this._mutantContainer.id = "_MutantContainer_" + a.Util.stamp(this._mutantContainer), this._mutantContainer.style.pointerEvents = "none", this._map.getContainer().appendChild(this._mutantContainer)), this.setOpacity(this.options.opacity), this.setElementSize(this._mutantContainer, this._map.getSize()), this._attachObserver(this._mutantContainer);
      },
      _initMutant: function _initMutant() {
        if (this._ready && this._mutantContainer) {
          this._mutantCenter = new n.maps.LatLng(0, 0);
          var t = new n.maps.Map(this._mutantContainer, {
            center: this._mutantCenter,
            zoom: 0,
            tilt: 0,
            mapTypeId: n.maps.MapTypeId[this._type],
            disableDefaultUI: !0,
            keyboardShortcuts: !1,
            draggable: !1,
            disableDoubleClickZoom: !0,
            scrollwheel: !1,
            streetViewControl: !1,
            styles: this.options.styles || {},
            backgroundColor: "transparent"
          });
          this._mutant = t, this.fire("spawned", {
            mapObject: t
          });
        }
      },
      _attachObserver: function _attachObserver(t) {
        new MutationObserver(this._onMutations.bind(this)).observe(t, {
          childList: !0,
          subtree: !0
        });
      },
      _onMutations: function _onMutations(t) {
        for (var e = 0; e < t.length; ++e) {
          for (var i = t[e], n = 0; n < i.addedNodes.length; ++n) {
            var o = i.addedNodes[n];
            o instanceof HTMLImageElement ? this._onMutatedImage(o) : o instanceof HTMLElement && Array.prototype.forEach.call(o.querySelectorAll("img"), this._onMutatedImage.bind(this));
          }
        }
      },
      _roadRegexp: /!1i(\d+)!2i(\d+)!3i(\d+)!/,
      _satRegexp: /x=(\d+)&y=(\d+)&z=(\d+)/,
      _staticRegExp: /StaticMapService\.GetMapImage/,
      _onMutatedImage: function _onMutatedImage(t) {
        var e,
            i,
            n,
            o = t.src.match(this._roadRegexp);

        if (o ? (e = {
          z: o[1],
          x: o[2],
          y: o[3]
        }, this._imagesPerTile > 1 && (t.style.zIndex = 1), i = 1) : ((o = t.src.match(this._satRegexp)) && (e = {
          x: o[1],
          y: o[2],
          z: o[3]
        }), i = 0), e) {
          var r = this._tileCoordsToKey(e);

          t.style.position = "absolute", this._imagesPerTile > 1 && (r += "/" + i), r in this._tileCallbacks && this._tileCallbacks[r] ? (this._tileCallbacks[r].pop()(t), this._tileCallbacks[r].length || delete this._tileCallbacks[r]) : ((n = t.parentNode) && (n.removeChild(t), n.removeChild = a.Util.falseFn), r in this._freshTiles ? this._freshTiles[r].push(t) : this._freshTiles[r] = [t]);
        } else t.src.match(this._staticRegExp) && (n = t.parentNode) && t.parentNode.replaceChild(a.DomUtil.create("img"), t);
      },
      _createSingleTile: function _createSingleTile(t, e) {
        var i = this._tileCoordsToKey(t);

        if (i in this._freshTiles) {
          var n = this._freshTiles[i].pop();

          return this._freshTiles[i].length || delete this._freshTiles[i], a.Util.requestAnimFrame(e), n;
        }

        var o,
            r = a.DomUtil.create("div");
        return this._tileCallbacks[i] = this._tileCallbacks[i] || [], this._tileCallbacks[i].push((o = r, function (t) {
          var i = t.parentNode;
          i && (i.removeChild(t), i.removeChild = a.Util.falseFn), o.appendChild(t), e();
        })), r;
      },
      _createMultiTile: function _createMultiTile(t, e) {
        var i = this._tileCoordsToKey(t),
            n = a.DomUtil.create("div");

        n.dataset.pending = this._imagesPerTile;

        for (var o = 0; o < this._imagesPerTile; o++) {
          var r = i + "/" + o;
          r in this._freshTiles ? (n.appendChild(this._freshTiles[r].pop()), this._freshTiles[r].length || delete this._freshTiles[r], n.dataset.pending--) : (this._tileCallbacks[r] = this._tileCallbacks[r] || [], this._tileCallbacks[r].push(function (t) {
            return function (i) {
              var n = i.parentNode;
              n && (n.removeChild(i), n.removeChild = a.Util.falseFn), t.appendChild(i), t.dataset.pending--, parseInt(t.dataset.pending) || e();
            };
          }(n)));
        }

        return parseInt(n.dataset.pending) || a.Util.requestAnimFrame(e), n;
      },
      _checkZoomLevels: function _checkZoomLevels() {
        void 0 !== this._map.getZoom() && this._mutant.getZoom() !== this._map.getZoom() && this._map.setZoom(this._mutant.getZoom());
      },
      _reset: function _reset() {
        this._initContainer();
      },
      _update: function _update() {
        if (a.GridLayer.prototype._update.call(this), this._mutant) {
          var t = this._map.getCenter(),
              e = new n.maps.LatLng(t.lat, t.lng);

          this._mutant.setCenter(e), void 0 !== this._map.getZoom() && this._mutant.setZoom(Math.round(this._map.getZoom()));
        }
      },
      _resize: function _resize() {
        var t = this._map.getSize();

        this._mutantContainer.style.width === t.x && this._mutantContainer.style.height === t.y || (this.setElementSize(this._mutantContainer, t), this._mutant && n.maps.event.trigger(this._mutant, "resize"));
      },
      _handleZoomAnim: function _handleZoomAnim() {
        var t = this._map.getCenter(),
            e = new n.maps.LatLng(t.lat, t.lng);

        this._mutant.setCenter(e), this._mutant.setZoom(Math.round(this._map.getZoom()));
      },
      _removeTile: function _removeTile(t) {
        if (this._imagesPerTile > 1) for (var e = 0; e < this._imagesPerTile; e++) {
          var i = t + "/" + e;
          i in this._freshTiles && delete this._freshTiles[i];
        } else t in this._freshTiles && delete this._freshTiles[t];
        return a.GridLayer.prototype._removeTile.call(this, t);
      }
    }), a.gridLayer.googleMutant = function (t) {
      return new a.GridLayer.GoogleMutant(t);
    };
  }, function (t, e) {
    t.exports = n;
  }]);
});